import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ConfigModule,
  I18nModule,
  OccEndpoint,
  provideDefaultConfig,
} from '@spartacus/core';
import { CmsConfig } from '@spartacus/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FormErrorsModule, SpinnerModule } from '@spartacus/storefront';
import {
  RECAPTCHA_SETTINGS,
  RecaptchaFormsModule,
  RecaptchaModule,
  RecaptchaSettings,
} from 'ng-recaptcha';
import { EnvironmentService } from '../../../environment.service';
import { NYABHomePageComponent } from './components/nyabhome-page.component';


@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        I18nModule,
        SpinnerModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        FormErrorsModule,
        ConfigModule.withConfig(<CmsConfig>{
            cmsComponents: {
                NYABHomePageFlexComponent: {
                    component: NYABHomePageComponent,
                },
            },
            skipLinks: [],
        }),
        NYABHomePageComponent,
    ],
    providers: [
        provideDefaultConfig({
            backend: {
                occ: {
                    endpoints: {
                        orderDeliveryStatus: '/nyab/ordersDeliverytatus',
                    },
                },
            },
        }),
        {
            provide: RECAPTCHA_SETTINGS,
            useFactory: (config: EnvironmentService): RecaptchaSettings => {
                return { siteKey: config.getConfig().googleReCaptchaKey };
            },
            deps: [EnvironmentService],
        },
    ],
    exports: [NYABHomePageComponent],
})
export class NYABHomePageModule { }
declare module '@spartacus/core' {
  interface OccEndpoints {
    orderDeliveryStatus?: string | OccEndpoint;
  }
}
